import React, {useCallback, useEffect, useState} from 'react';
import styled from 'styled-components';

import Tree from '../Tree';
import Button from '../Button';
import Icon from '../Icon';

function QuestionSelectorTree({ forms, expandAll, onSelect, selected }) {
  const [expandedForms, setExpandedForms] = useState({});

  useEffect(() => {
    if (expandAll) {
      setExpandedForms(
        forms.reduce((map, form) => {
          map[form.id] = true;
          return map;
        }, {})
      );
    }
    else {
      setExpandedForms({});
    }
  }, [expandAll, forms, setExpandedForms]);

  const toggleFormExpanded = useCallback(form => {
    setExpandedForms(forms => {
      const isExpanded = forms[form.id];
      
      return {
        ...forms, 
        [form.id]: !isExpanded
      };
    });
  }, [setExpandedForms]);

  const renderLabel = useCallback((item, depth) => {
    if (depth === 0) {
      // Render the label for a form.
      const isExpanded = expandedForms[item.id];

      return (
        <TreeButton block tertiary onClick={() => toggleFormExpanded(item)}>
          {isExpanded ? <Icon name="chevron-down" /> : <Icon name="chevron-right" />} {item.name}
        </TreeButton>
      );
    }

    if (depth === 1) {
      // Render the label for a question.
      return (
        <TreeButton tertiary onClick={() => onSelect(item)}>
          <input type="checkbox" checked={selected === item} /> {item.text}
        </TreeButton>
      );
    }
  }, [expandedForms, toggleFormExpanded, onSelect, selected]);

  const renderChildren = useCallback((item, depth) => {
    if (depth > 0 || !expandedForms[item.id]) {
      return null;
    }
    
    return [...item.contextQuestions, ...item.questions].sort((a, b) => b.order - a.order);
  }, [expandedForms]);

  return (
    <Tree
      items={forms}
      children={renderChildren}
      label={renderLabel}
    />
  );
}

const TreeButton = styled(props => <Button {...props} block tertiary />)`
  text-align: left;
`;

export default QuestionSelectorTree;